import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-standarts-tabs-admin',
  templateUrl: './standarts-tabs-admin.component.html',
  styleUrls: ['./standarts-tabs-admin.component.css']
})
export class StandartsTabsAdminComponent implements OnInit {

  flag = true;
  constructor() { }

  ngOnInit() {
  }

  change(data) {
    this.flag = data;
  }
  
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standarts-tabs-admin/standarts-tabs-admin.component.ts